'use strict';

export function initMenuToggle() {
  const toggleButton = document.querySelector('[data-collapse-toggle]');

  if (!toggleButton) {
    console.warn('Menu toggle button not found');
    return;
  }

  const menuId = toggleButton.getAttribute('data-collapse-toggle');
  const mobileMenu = document.getElementById(menuId);

  if (!mobileMenu) {
    console.warn('Menu toggle elements not found');
    return;
  }

  const hamburgerIcon = toggleButton.querySelector('svg:first-of-type');
  const closeIcon = toggleButton.querySelector('svg:last-of-type');



  // Toggle hlavního menu (hamburger)
  toggleButton.addEventListener('click', function() {
    // Toggle opacity a pointer-events
    mobileMenu.classList.toggle('menu--main--open');

    // Zamknout scroll na body když je menu otevřené
    document.body.style.overflow = mobileMenu.classList.contains('menu--main--open') ? 'hidden' : '';

    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    toggleButton.setAttribute('aria-expanded', !isExpanded);
    hamburgerIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
  });

  // Zavřít menu při kliknutí na odkaz (pouze mobil)
  const menuLinks = mobileMenu.querySelectorAll('a');
  menuLinks.forEach(link => {
    link.addEventListener('click', function() {
      if (window.innerWidth < 1024) {
        mobileMenu.classList.toggle('menu--main--open');
        document.body.style.overflow = '';
        toggleButton.setAttribute('aria-expanded', 'false');
        hamburgerIcon.classList.remove('hidden');
        closeIcon.classList.add('hidden');
      }
    });
  });
}
